import Cta from "@components/Cta/Cta";
import clsx from "clsx";
import { useRouter } from "next/router";
import { EDIT_PROFILE_URL } from "../../constants/index";
import styles from "./C63_1_MyProfilePersonalDetails.module.scss";

interface EditDetailsBtnProps {
  sectionTitle: string;
}

export const EditDetailsBtn = ({ sectionTitle }: EditDetailsBtnProps) => {
  const router = useRouter();

  const handleOnEditDetailsClick = () => {
    router.push(EDIT_PROFILE_URL);
  };

  return (
    <div className={clsx(styles["field-row"], styles["edit-details"])}>
      <Cta
        onClick={handleOnEditDetailsClick}
        url=""
        renderAs="button"
        light={false}
        type="primary"
        linkText="Edit Details"
        ariaLabel={`${sectionTitle} edit details`}
      />
    </div>
  );
};
